import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { finalize } from 'rxjs';
import { AppModeService } from 'src/app/services/app-mode.service';
import { AuthService } from 'src/app/services/auth/auth.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  isMobileApp = false;
  emailValue = '';
  passwordValue = '';
  showPassword = false;
  isLoading = false;
  emailError = '';
  passwordError = '';
  loginError = '';

  constructor(
    private readonly appModeService: AppModeService,
    private readonly authService: AuthService,
    private readonly router: Router,
    private readonly route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.isMobileApp = this.appModeService.isApp();
  }

  togglePasswordVisibility(): void {
    this.showPassword = !this.showPassword;
  }

  clearEmail(): void {
    this.emailValue = '';
    this.emailError = '';
  }

  clearPassword(): void {
    this.passwordValue = '';
    this.passwordError = '';
  }

  validateAndSubmit(): void {
    this.emailError = '';
    this.passwordError = '';
    this.loginError = '';

    const email = this.emailValue.trim();
    const password = this.passwordValue;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    let hasError = false;

    if (!emailRegex.test(email)) {
      this.emailError = 'LOGIN.ERROR_INVALID_EMAIL';
      hasError = true;
    }

    if (!password || password.trim().length < 6) {
      this.passwordError = 'LOGIN.ERROR_INVALID_PASSWORD';
      hasError = true;
    }

    if (hasError) {
      return;
    }

    this.isLoading = true;

    this.authService
      .login(email, password)
      .pipe(finalize(() => (this.isLoading = false)))
      .subscribe({
        next: () => {
          const lang = this.route.snapshot.paramMap.get('lang') || 'en';
          this.router.navigateByUrl(`/${lang}/home`);
        },
        error: (error) => {
          this.loginError = error?.error?.message || 'LOGIN.ERROR_LOGIN_FAILED';
        },
      });
  }

  navigateBack(): void {
    const lang = this.route.snapshot.paramMap.get('lang') || 'en';
    this.router.navigateByUrl(`/${lang}/home`);
  }

  navigateToRegister(): void {
    const lang = this.route.snapshot.paramMap.get('lang') || 'en';
    this.router.navigate([lang, 'register']);
  }

  navigateToForgotPassword(): void {
    const lang = this.route.snapshot.paramMap.get('lang') || 'en';
    this.router.navigate([lang, 'forgot-password']);
  }
}
